import { Avatar as AntdAvatar } from "@dreambigger/design-system";
interface AvatarProps {
  imgUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  className?: string;
  size?: number | "small" | "large";
}

const Avatar = ({
  imgUrl,
  firstName,
  lastName,
  className,
  size = "large",
}: AvatarProps) => {
  return (
    <div className={className}>
      <AntdAvatar size={size} className="bg-primary bn" src={imgUrl}>
        <span className={`${size === "small" && "f-2"}`}>
          {firstName && firstName.charAt(0)}
        </span>
        <span className={`${size === "small" && "f-2"}`}>
          {lastName && lastName.charAt(0)}
        </span>
      </AntdAvatar>
    </div>
  );
};

export default Avatar;